import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CancelButton } from './AdditionalButton';
import { HelpInfo } from './HelpInfo';


const Content = props => {
    const { stepName, cancelButton } = props;
    
    return (
        <React.Fragment>
        <Header />
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-6 offset-md-3 col-sm-8 offset-sm-2">
                    <h3 className="text text-center text-default">Criação de Conta Institucional</h3>
                    { stepName && <h5 className="text text-center step-color"> {stepName} </h5>}
                    <br />
                    <div className="content-body">
                        {props.children}
                        { cancelButton ? <CancelButton /> : null } 
                        <HelpInfo />                       
                    </div>                                        
                </div>                                
            </div>                        
        </div>        
        <Footer />
        </React.Fragment>
    );
}

export { Content };